import api from '../../../App/socket';

export const getUsersQuantity = groupId => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'Count',
        options:
      {
          where: {
              ref_user_group: groupId,
          },
      },
    }).then(response => response.options.amount).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/requests/get_users_quantity_request.js